import { http } from '../request'
import type {
    WalletBalance,
    WalletTransactionItem,
    WalletListRequest,
    WalletListResponse,
    UserRechargeRequest,
    UserRechargeResponse,
    RechargeOrderStatus,
    WithdrawalRequest,
    WithdrawalLimitInfo,
    CreateWithdrawalRequest,
    CreateWithdrawalResponse,
    WithdrawalListRequest,
    WithdrawalListResponse,
    WalletTransactionOrderDetail,
} from '../types/wallet'

export const walletApi = {
    // 用户端：获取钱包概览（包含余额和统计）
    getWalletOverview(): Promise<WalletBalance> {
        return http.get('/api/wallet/transactions/overview/')
    },

    // 用户端：获取流水
    getMyTransactions(params?: WalletListRequest): Promise<WalletListResponse> {
        return http.list<WalletTransactionItem>('/api/wallet/transactions/', params)
    },

    // ==================== 用户充值相关API ====================

    /**
     * 创建支付宝充值
     * POST /api/wallet/transactions/recharge/
     */
    rechargeByAlipay(data: UserRechargeRequest): Promise<UserRechargeResponse> {
        return http.post<UserRechargeResponse>('/api/wallet/transactions/recharge/', data)
    },

    /**
     * 查询充值状态 - 使用专门的轮询接口（参考游戏订单）
     * GET /api/wallet/transactions/recharge-status/{order_no}/
     */
    checkRechargeStatus(orderNo: string): Promise<RechargeOrderStatus> {
        return http.get<RechargeOrderStatus>(`/api/wallet/transactions/recharge-status/${orderNo}/`)
    },

    // ==================== 提现相关API ====================

    /**
     * 获取用户提现限额信息
     * GET /api/wallet/withdrawal-requests/limit-info/
     */
    getWithdrawalLimitInfo(): Promise<WithdrawalLimitInfo> {
        return http.get<WithdrawalLimitInfo>('/api/wallet/withdrawal-requests/limit-info/')
    },

    /**
     * 获取提现申请列表（只返回PENDING和REJECTED状态）
     * GET /api/wallet/withdrawal-requests/
     */
    getWithdrawalRequests(params?: WithdrawalListRequest): Promise<WithdrawalListResponse> {
        return http.list<WithdrawalRequest>('/api/wallet/withdrawal-requests/', params)
    },

    /**
     * 创建提现申请
     * POST /api/wallet/withdrawal-requests/
     */
    createWithdrawalRequest(data: CreateWithdrawalRequest): Promise<CreateWithdrawalResponse> {
        return http.post<CreateWithdrawalResponse>('/api/wallet/withdrawal-requests/', data)
    },

    /**
     * 撤销提现申请
     * POST /api/wallet/withdrawal-requests/{id}/cancel/
     */
    cancelWithdrawalRequest(id: number): Promise<{ request_no: string; status: string; status_display: string; processed_at: string }> {
        return http.post(`/api/wallet/withdrawal-requests/${id}/cancel/`, {})
    },

    /**
     * 获取钱包流水关联的订单详情（包含账号快照）
     * GET /api/wallet/transactions/{id}/order-detail/
     */
    getTransactionOrderDetail(id: number): Promise<WalletTransactionOrderDetail> {
        return http.get<WalletTransactionOrderDetail>(`/api/wallet/transactions/${id}/order-detail/`)
    }
}

export default walletApi


